import React, { Component } from 'react'
import Select from './Select'
import { i18n } from "../i18n/i18n";

interface ResultLimiterProps {
  value: string
  onChange: (limit: string) => void
}

interface ResultLimiterState {
  value: string
}

export default class ResultLimiter extends Component<ResultLimiterProps, ResultLimiterState> {
  options = [
    { name: '10', value: '10' },
    { name: '25', value: '25' },
    { name: '50', value: '50' },
    { name: '100', value: '100' }
  ]

  constructor (props: ResultLimiterProps) {
    super(props)
    this.state = {
      value: '25'
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (name: string, value: string) {
    this.setState({ value })
    this.props.onChange(value)
  }

  componentDidMount () {
    this.setState({ value: this.props.value })
  }

  render () {
    return (
      <div className="flex items-center">
        <p className="mr-3 mb-4">{i18n("Show")}</p>
        <Select
          name="limit"
          value={this.state.value}
          options={this.options}
          onChange={this.handleChange} />
        <p className="ml-3 mb-4">{i18n("results")}</p>
      </div>
    )
  }
}
